import React from 'react';
import { useHistory } from 'react-router-dom';
import NominaDescuentos from '../components/admin/NominaDescuentos';
import { getUserSession, isSuperAdmin } from '../services/authService';
import '../styles/admin.css';

const AdminDescuentosPage = () => {
  const history = useHistory();
  const session = getUserSession();
  const sessionId = session ? session.id : null;

  if (!session || !isSuperAdmin(session)) {
    return null;
  }

  return (
    <div className="admin-root">
      <section className="admin-section">
        <header className="admin-header">
          <div>
            <h1>Descuentos</h1>
            <p>Maestro de tipos de descuento. Se usarán al registrar inasistencias, incapacidades y vacaciones.</p>
          </div>
        </header>
        <NominaDescuentos sessionId={sessionId} onSalir={() => history.push('/admin/configuracion')} />
      </section>
    </div>
  );
};

export default AdminDescuentosPage;
